<template>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-12">
                    <np-checkbox v-if="!isView && !isBundlePackage"
                            :id="`${id}_selected`"
                            :name="`${name}[selected]`"
                            :no-wrapper="true"
                            :model-value="itemIsSelected(bundle_item)"
                            :required="!hasSelectedTerminals && !hasSelectedBundlePackage"
                            :disabled="itemIsDisabled(bundle_item)"
                            :description="bundle_item.equipment.equipment_name"
                            :checked="itemIsSelected(bundle_item)"
                            :on-selected="function() {
                                                                      if(!bundle_item.terminal_quantity > 0 ){
                                                                        bundle_item.terminal_quantity = 1
                                                                        bundle_item.selected = true;
                                                                        bundle_item.is_boarding_activated = '1';
                                                                      }
                                                                      $emit('terminal-toggled', bundle_item)
                                                                    }"
                            :on-deselected="() => { bundle_item.terminal_quantity = 0; bundle_item.selected = false;
                            bundle_item.is_boarding_activated = '0';
                            getBundleItemFeatures(bundle_item).forEach(obj => {
                              obj.selected = '';
                            })
                            }">
                    </np-checkbox>
                    <span v-else>{{ bundle_item.equipment.equipment_name}}</span>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12 col-sm-2">
                    <img :src="getBundleItemEquipmentFirstImage(bundle_item)" class="card-img avatar-small">
                </div>
                <div class="col-12 col-sm-5 col-md-5 col-lg-6">
                    <div class=""  v-if="itemHasDescription(bundle_item)">
                        <span class="labelLook boldText">{{lang('description')}}</span>

                        <np-show-less ref="equipment_description"
                                      :id="id"
                                    :description="bundle_item.equipment.equipment_description" >
                        </np-show-less>
                    </div>
                    <div class="" v-if="itemHasFeatures(bundle_item)">
<!--                        <span class="labelLook boldText">{{lang('features')}}</span>-->
                        <template v-for="(feature, feature_idx) in getBundleItemFeatures(bundle_item)">
                            <div class="row marginTop5" v-if="feature.is_selectable  && !isView">
                                <div class="col-md-12">
                                    <np-checkbox
                                            :no-wrapper="true"
                                            ref="equipment_feature"
                                            :name="`${name}[feature][${feature_idx}][selected]`"
                                            :id="`${id}_feature_${feature_idx}_selected`"
                                            :value="feature.feature_external_id"
                                            @change="featureIsSelected(feature)"
                                            :aria-label="feature.feature_name"
                                            :disabled="bundle_item.terminal_quantity < 1"
                                            :description="feature.feature_name"
                                            :on-deselected=" () => feature.value = ''"
                                            :help-text="!!feature.help_text ? feature.help_text : ''"
                                            v-model="feature.selected">
                                    </np-checkbox>
                                </div>
                                <div class="col-md-12">
                                    <np-input
                                            v-if="feature.feature_input_type === types.TEXT"
                                            :aria-label="feature.feature_name"
                                            :name="`${name}[feature][${feature_idx}][value]`"
                                            :id="`${id}_feature_${feature_idx}_value`"
                                            :rules="[]"
                                            :required="true"
                                            ref="equipment_feature_value"
                                            :minlength="feature.minimum"
                                            :maxlength="feature.maximum"
                                            :disabled="feature.selected !== '1'"
                                            :no-wrapper="true"
                                            v-model="feature.value">
                                    </np-input>
                                    <np-input
                                            v-else-if="feature.feature_input_type === types.NUMERIC"
                                            :aria-label="feature.feature_name"
                                            :name="`${name}[feature][${feature_idx}][value]`"
                                            :id="`${id}_feature_${feature_idx}_value`"
                                            :rules="['numeric']"
                                            :required="true"
                                            ref="equipment_feature_value"
                                            :min="feature.minimum"
                                            :max="feature.maximum"
                                            :disabled="feature.selected !== '1'"
                                            :no-wrapper="true"
                                            v-model="feature.value">
                                    </np-input>

                                    <np-select2
                                            v-else-if="feature.feature_input_type === types.LIST"
                                            :aria-label="feature.feature_name"
                                            :name="`${name}[feature][${feature_idx}][value]`"
                                            :id="`${id}_feature_${feature_idx}_value`"
                                            :show-label="true"
                                            ref="equipment_feature_value"
                                            :parameters="getFeatureList(feature)"
                                            :required="true"
                                            :no-wrapper="true"
                                            :multi="true"
                                            :disabled="feature.selected !== '1'"
                                            v-model="feature.value">
                                    </np-select2>

                                    <np-radios  v-else-if="feature.feature_input_type === types.BOOLEAN"
                                                ref="equipment_feature_value"
                                                :name="`${name}[feature][${feature_idx}][value]`"
                                                :id="`${id}_feature_${feature_idx}_value`"
                                                :min="feature.minimum"
                                                :max="feature.maximum"
                                                :options="parameters.YES_NO_OPTIONS"
                                                :mode="'co-join'"
                                                :no-wrapper="true"
                                                :hide-label="true"
                                                :disabled="feature.selected !== '1'"
                                                v-model="feature.value">
                                    </np-radios>
                                </div>
                            </div>
                            <ul class="row" v-else-if="isView">
                                <li class="">
                                    {{feature.feature_name}}
                                </li>
                            </ul>
                            <ul class="row" v-else>
                                <li class="">
                                    {{feature.feature_name}}
                                </li>
                            </ul>
                        </template>

                    </div>
                </div>
                <div class="col-12 col-sm-5 col-md-5 col-lg-4">
                    <div class="row">
                        <div class="col-12">
<!--                            <np-input-->
<!--                                    :label="lang('price')"-->
<!--                                    :id="`${id}_price`"-->
<!--                                    :name="`${name}[price]`"-->
<!--                                    :readonly="true"-->
<!--                                    :split="0.3"-->
<!--                                    :addon-on-left="true"-->
<!--                                    :value="getCost(bundle_item)">-->
<!--                                <span slot="addon">{{currencySymbol}}</span>-->
<!--                            </np-input>-->
                            <np-entry
                                :label="priceLabel"
                                 mode="inline"
                                :split="0.5"
                                :model-value="`${getCost(bundle_item)}`">
                            </np-entry>
                        </div>
                        <div class="col-12" v-if="isMultiTerminal(bundle,bundle_item)">
                            <np-input
                                :label="lang('quantity')"
                                :disabled="!is_editable_quantity"
                                style=""
                                ref="equipment_quantity"
                                :split="0.5"
                                type="numeric"
                                :check_config="false"
                                :name="`${name}[terminal_quantity]`"
                                :key="`${id}_terminal_quantity_${bundle_item.is_boarding_activated}`"
                                :id="`${id}_terminal_quantity`"
                                :rules="isRequired(bundle_item) ? ['is_natural', 'required', {'greater_than_equal' : '1'}, {'less_than_equal' : '9'}] : ['is_natural', {'greater_than_equal' : '1'}, {'less_than_equal' : '9'}]"
                                :no-wrapper="false"
                                @input="toggleEquipmentSelection(bundle_item, bundle_item.terminal_quantity)"
                                v-model="bundle_item.terminal_quantity">
                            </np-input>
                        </div>
                        <div class="col-12" v-if="isMultiTerminal(bundle,bundle_item)">
                            <hr class="terminal-divider-line">
                        </div>
                        <div class="col-12" v-if="isMultiTerminal(bundle,bundle_item)">
<!--                            <np-input-->
<!--                                    :label="lang('total')"-->
<!--                                    :id="`${id}_total`"-->
<!--                                    :name="`${name}[total]`"-->
<!--                                    :readonly="true"-->
<!--                                    :split="0.5"-->
<!--                                    :disabled="true"-->
<!--                                    :addon-on-left="true"-->
<!--                                    :value="getTotal(bundle_item)">-->
<!--                                <span slot="addon">{{currencySymbol}}</span>-->
<!--                            </np-input>-->
                            <np-entry
                                :label="lang('total')"
                                mode="inline"
                                :split="0.5"
                                :model-value="getTotal(bundle_item)">
                            </np-entry>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import utilMixin from "../utils/mixins";
    import applicationMixin from "../utils/application-mixin";
    import equipmentMixin from "../utils/equipment-mixin";
    import NpMultiselect from "netpify/components/np-multiselect.vue";
    import {
        NPCheckBox,
        NPEntry,
        NPInput,
        NPNotice,
        NPRadios,
        NPResponsive,
        NPSelect2,
        NPSkeleton,
        NPShowLess
    } from "netpify/components";

    export default {
        name: "equipment-terminals",
        mixins: [utilMixin, applicationMixin, equipmentMixin],
        components: {
            'np-multiselect': NpMultiselect,
            'np-entry': NPEntry,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-select2': NPSelect2,
            'np-responsive': NPResponsive,
            'np-skeleton': NPSkeleton,
            'np-checkbox': NPCheckBox,
            'np-notice': NPNotice,
            'np-show-less': NPShowLess,
        },
        props: {
            bundle: {
                default() {
                    return {}
                }
            },
            bundle_item: {
                default() {
                    return {}
                }
            },
            accessoryType: Boolean,
            id: {
                default() {
                    return 'quote' + Math.random().toString()
                }
            },
            name: {
                default() {
                    return 'quote' + Math.random().toString()
                }
            },
            isView: Boolean,
            isBundlePackage: Boolean,
            bundlePackageSelected: Boolean,
        },
        computed: {
            minVal: function () {
                return this.bundle_item.is_mandatory === '1' ? 1 : 0
            },
            is_editable_quantity: function () {
                if (this.isView) {
                    return false;
                }
                if  (this.bundle_item.terminal_quantity < 1) {
                    return false;
                }
                //logic to set readonly based on feature_api_codes
                if (this.isFeatureCodeConfiguredInBundleItem(this.bundle_item, this.FEATURE_CODE_SINGLE)) {
                    return false;
                }
                return true;
            },
            priceLabel: function () {
                let agreement_length = this.bundle_item.agreement_length;
                if (this.isView && !!this.quote.equipment_offer && !!this.quote.equipment_offer.agreement_length) {
                    agreement_length = this.quote.equipment_offer.agreement_length;
                }
                if (agreement_length !== 'PURCHASE') {
                    return this.lang('price_per_month')
                } else {
                    return this.lang('unit_price')
                }
            }
        },
        methods: {
            itemIsDisabled: function (bundle_item) {
                return this.isView ? true : this.isBundlePackage ? true : this.equipmentIsDisabled(bundle_item);
            },
            itemIsSelected: function (bundle_item) {
                // this.cleanCustomEquipments(this.bundle, bundle_item) currently not needed
                return this.isBundlePackage ? this.bundlePackageSelected ? '1' : '0' : this.equipmentIsSelected(bundle_item);
            },
            itemHasDescription: function (bundle_item) {
                return bundle_item.equipment.hasOwnProperty('equipment_description') &&
                    bundle_item.equipment.equipment_description !== '';
            }
        }
    }
</script>

<style scoped>
    ul:not(.nav-pills) {
        list-style: none;
    }

    li:not(.nav-item) {
        font-weight: lighter;
        font-size: 0.8em;
    }

    li:not(.nav-item):before {
        content: "\f054"; /* FontAwesome Unicode fa-chevron-right*/
        font-family: 'Font Awesome 5 Free';
        font-weight: 900;
        display: inline-block;
        margin-left: -1.3em; /* same as padding-left set on li */
        width: 1.3em; /* same as padding-left set on li */
    }

    img {
        display: block;
        margin-left: auto;
        margin-right: auto;
        max-width: 100%;
        height: auto
    }

    .avatar-small {
        width: 100px;
        border-radius: 6px;
        display: block;
        padding: 2px;
        margin: 10px auto;
    }

    /*.avatar-small:hover {*/
    /*    box-shadow: 0 0 2px 1px rgba(66, 153, 225, 1);*/
    /*    -ms-transform: scale(2.5); !* IE 9 *!*/
    /*    -webkit-transform: scale(2.5); !* Safari 3-8 *!*/
    /*    transform: scale(2.5);*/
    /*    cursor: pointer;*/
    /*    z-index: 99999;*/
    /*}*/

    .vue-radio-checkbox.np-checkbox.default.form-group {
        min-height: 0 !important;
    }


</style>
